import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import {Feed} from '../../models/feed';
import {Comment} from '../../models/comment';
import {FeedService} from '../../services/feed.service';
import {AuthService} from '../../services/auth.service';
import filestack from 'filestack-js';

import { ModalFeedComponent } from '../feed/modal-feed/modal-feed.component';
import { ModalContentComponent } from '../feed/modal-content/modal-content.component';

declare var $: any;
import Swal from 'sweetalert2';

const apikey = 'A7zJTtgFRW6cWqHglvjIgz';
const client = filestack.init(apikey);

@Component({
  selector: 'app-feed-user',
  templateUrl: './feed-user.component.html',
  styleUrls: ['./userpanel.component.css'],
  providers: [ FeedService, AuthService ]
})

export class FeedUserComponent {

  @Input() client: string;

  public feedArray: any;

  public form: FormGroup;
  public formComment: FormGroup;
  public loggedInUser: any;
  public loaderActivated: any = false;

  public loadingMore: boolean;

  public currentPage: number;
  public countPage: number;

  public uploadedFileType: string;
  public uploadedFileUrl: string;


  constructor(
    private feedService: FeedService,
    public fb: FormBuilder,
    private authService: AuthService,
    public dialog: MatDialog
  ) {
    this.buildForm();
    this.loaderActivated = true;
    this.loadingMore = false;

    const _this = this;

    $(window).scroll(function () {
      if ($(window).scrollTop() + $(window).height() == $(document).height()) {

      }
    });
  }

  getUsuarioLogado(): any {
    const loggedUser = JSON.parse(sessionStorage.getItem('loggedUser'));
    this.loggedInUser = loggedUser.data;
  }

  showFilePicker() {
    const component = this;
    client.pick({
      fromSources: ['local_file_system', 'url', 'imagesearch', 'webcam', 'video'],
      accept: ['image/*', 'video/*'],
      uploadInBackground: false,
      maxFiles: 1,
      lang: 'pt'
    }).then(function (response) {
      component.uploadedFileUrl = response.filesUploaded['0'].url;
      component.uploadedFileType = component.getTypeByMimeType(response.filesUploaded['0'].mimetype);
      console.log(response);
    });
  }

  getTypeByMimeType(mime: string): string {
    const split = mime.split('/');
    return split[0];
  }

  resetFilePicker() {
    this.uploadedFileType = null;
    this.uploadedFileUrl = null;
  }

  ngOnInit() {

    this.getUsuarioLogado();

    this.getFeed();

    let _this = this;

    this.feedService.feedChannel
      .bind('my-event-' + this.client, function (result) {

        if (result.type === 'item') {
          _this.feedArray.unshift(result.data);
        }

        if (result.type === 'comments') {
          console.log('aqui')
            let item = _this.feedArray.find(function (item) {
                return item.id == result.target;
            });
            if (item) {
                item.comments.data.unshift(result.data);
            }
        }

        if (result.type === 'updatePost') {
          console.log(_this.feedArray)
          let item = _this.feedArray.find(function (item) {
            return item.id === result.data.id;
          });
          if (item) {
            item.text = result.data.text;
            item.embed = result.data.embed;
            item.embedTipo = result.data.embedTipo;
            item.image = result.data.image;
          }
        }
        console.log('result')
        console.log(result)
    });
  }

  getFeed() {
    this.feedArray = [];
    this.feedService.getFeedUser()
      .subscribe(result => {
        this.feedArray = result.data;
        console.log(this.feedArray)
        this.loaderActivated = false;
      });
  }

  deleteFeed(id) {
    Swal.fire({
      title: 'Você quer apagar o item?',
      text: 'Você não poderá reverter essa ação depois de confirmado',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then(
      (result) => {
        if (result.value) {
          this.feedService.deleteFeed(id).subscribe(
            res => {
              for (let i = 0; i < this.feedArray.length; i++) {
                if (this.feedArray[i].id === id) {
                  this.feedArray.splice(i, 1);
                  break;
                }
              }
            }
          )                    
        }

      },
      (cancel) => {}
    );
  }


  buildForm(): void {
    this.form = this.fb.group({
      texto: ['', Validators.minLength(5)],
    });
    this.formComment = this.fb.group({
      comment: ['', Validators.minLength(5)],
    });
  }

  onSubmit(): any {
    this.feedService.publishNewPost(this.preparePostItem())
      .subscribe(res => {
         this.getFeed();
      });
    this.form.reset();
  }

  onSubmitComment(id: number): any {
    this.feedService.publishNewComment(this.prepareComment(id))
      .subscribe(res => {
        this.getFeed();
      });
    this.formComment.reset();
  }

  preparePostItem(): Feed {
    const formModel = this.form.value;
    const feed = new Feed();
    const embed = this.checkIfHasEmbededVideo(formModel.texto);

    // @TODO: Resolver problema de pasta forçada

    feed.pasta_id = 1;
    feed.titulo = formModel.texto;
    feed.texto = formModel.texto;
    feed.author = this.loggedInUser.name;

    if (typeof embed === 'object') {
      feed.embed = embed.url;
      feed.texto = '';
      feed.titulo = 'Embed';
    } else {
      feed.embed = '';
    }

    if (this.uploadedFileUrl && this.uploadedFileType === 'video') {
      feed.embedTipo = 'file';
      feed.embed = this.uploadedFileUrl;
    }

    if (this.uploadedFileUrl && this.uploadedFileType === 'image') {
      feed.image = this.uploadedFileUrl;
    }

    this.resetFilePicker();

    return feed;
  }


  prepareComment(id: number): Comment {
    const formModel = this.formComment.value;
    const obj = new Comment();
    obj.comment = formModel.comment;
    obj.feed_itens_id = id;
    return obj;
  }

  checkIfHasEmbededVideo(value: string): any {
    if (value.includes('vimeo')) {
      return {url: '//player.vimeo.com/video/' + value.split('/')[4]};
    } else if (value.includes('youtube')) {
      return {url: '//www.youtube.com/embed/' + value.split('=')[1]};
    } else {
      return value;
    }
  }

  like(item: any) {
    if (item.isLike === 1) {
      item.isLike = 0;
      item.Likes--;
    } else {
      item.isLike = 1;
      item.Likes++;
    }

    this.feedService.like(item.id).subscribe(res => {
      console.log(res);
    });
  }

  ExpandImg(image) {
    const dialogRef = this.dialog.open(ModalFeedComponent, {
      panelClass: 'full-screen-dialog',
      data: { img: image }
    });
  }

  openUpdateModal(item) {
    const dialogRef = this.dialog.open(ModalContentComponent, {
      width: '650px',
      maxHeight: '80%',
      data: item
    });

    dialogRef.afterClosed().subscribe(result => {
      // trocar pelo pusher
      if (result) {
        this.getFeed();
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/feed-user/feed-user.component.ts